<h1 mat-dialog-title class="dialog-title">
    <mat-icon>sync_alt</mat-icon>
    <span>Alterar Status em Massa</span>
</h1>

<div mat-dialog-content class="dialog-content">
    <p>Selecione o novo status:</p>
    <mat-form-field appearance="outline" class="w-100">
        <mat-label>Status</mat-label>
        <mat-select [(ngModel)]="selectedStatus">
            <mat-option [value]="true">Ativo</mat-option>
            <mat-option [value]="false">Inativo</mat-option>
        </mat-select>
    </mat-form-field>
</div>

<div mat-dialog-actions align="end" class="mat-mdc-dialog-actions">
    <button mat-stroked-button class="btn-secondary" (click)="cancelar()">Cancelar</button>
    <button mat-flat-button class="btn-primary" [disabled]="selectedStatus === null"
        (click)="confirmar()">Salvar</button>
</div>